<template>
  <div class="content-container">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>管理</el-breadcrumb-item>
      <el-breadcrumb-item>公司信息</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="panel mt-20">
      <el-form
        style="width: 400px; max-width: 100%"
        :model="dealer"
        :rules="dealerRules"
        ref="dealerForm"
        label-width="100px"
        size="small"
      >
        <el-form-item label="公司名称" prop="name">
          <el-input
            :value="dealer.name"
            autocomplete="off"
            :disabled="true"
          ></el-input>
        </el-form-item>
        <el-form-item label="地区" prop="area">
          <el-cascader
            class="long"
            :options="regionData"
            v-model="dealer.area"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="地址" prop="address_detail">
          <el-input
            v-model="dealer.address_detail"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="tel">
          <el-input v-model="dealer.tel" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="传真" prop="fax">
          <el-input v-model="dealer.fax" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="对外邮箱" prop="email">
          <el-input v-model="dealer.email" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="公司代码" prop="company_code">
          <div class="text-info-12">公司代码用于生成各类单号</div>
          <el-input
            class="fixed_uppercase"
            v-model="dealer.company_code"
            placeholder="请输入公司代码，1-4位字母"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <el-button
        style="margin-left: 80px"
        size="small"
        type="primary"
        class="mobile-ml-0"
        @click="submitDealerForm('dealerForm')"
        >保 存</el-button
      >
    </div>
  </div>
</template>

<script>
import { dealerInfo, updateDealer } from '@/service/getData'
import { clone } from '@/util'
import { regionData } from '@/util/area_tool'

export default {
  watch: {},
  data() {
    let companyCodeValidator = (rule, value, callback) => {
      let reg = /^[A-Za-z]{1,4}$/
      console.log(reg.test(value))
      if (!reg.test(value)) {
        callback(new Error('请输入1-4位字母'))
      } else {
        callback()
      }
    }

    return {
      regionData: regionData,
      dealer: {},
      dealerRules: {
        company_code: [
          {
            required: true,
            message: '请输入公司代码，1-4位字母',
            trigger: 'blur',
          },
          { validator: companyCodeValidator, trigger: 'blur' },
        ],
      },
    }
  },
  created() {
    this.initData()
  },
  methods: {
    async initData() {
      let res = await dealerInfo()
      if (res.code == 0) {
        this.dealer = res.data
        this.dealer.area = [
          this.dealer.province_id,
          this.dealer.city_id,
          this.dealer.county_id,
        ]
      }
    },

    submitDealerForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let area = this.dealer.area
          if (area.length > 0) {
            this.dealer.province_id = area[0]
          }
          if (area.length > 1) {
            this.dealer.city_id = area[1]
          }
          if (area.length > 2) {
            this.dealer.county_id = area[2]
          }

          this.dealer.company_code = this.dealer.company_code.toUpperCase()
          let res = await updateDealer(this.dealer)
          if (res.code == 0) {
            this.$message({
              message: '保存成功',
              type: 'success',
              center: true,
            })
          }
        }
      })
    },
  },
}
</script>

<style scoped>
.long {
  width: 100%;
}
/deep/.fixed_uppercase .el-input__inner {
  text-transform: uppercase !important;
}
</style>s